export { FRIENDS } from "./friends.data";
export { VIDEOS } from "./videos.data";



/** WEBPACK FOOTER **
 ** ./src/data/index.js
 **/